// extracted by mini-css-extract-plugin
export var darkMode = "_p-0";